export const managerPrices = {
  page: {
    title: "Platform prices",
    subtitle: "List of prices for the platform plans",
  },
  table: {
    name: "Name",
    type: "Type",
    price: "Price",
    created: "Created",
    edit: "Edit price",
  },
  form: {
    title: "Update price",
    planName: "Plan name",
    planType: "Plan type",
    annual: "Annual",
    monthly: "Monthly",
    cancel: "Cancel",
    save: "Save",
  },
  toast: {
    saved: "Saved successfully",
    error: "Request error",
  },
};
